// extracted by mini-css-extract-plugin
module.exports = {"dropDownward":"styles_dropDownward__4dbYj","dropUpward":"styles_dropUpward__1FpS9"};